import styled from 'styled-components';
import { minMediaQueries, maxMediaQueries } from '@finect/tabular-utils/mediaQueries';
import { getFont } from '@finect/tabular-utils/getFont';

export const QuestionDetail = styled.div`
  ${({ theme, prePublish }) =>
    (prePublish
      ? `
      padding: 9px;
      background-color: ${theme.borderColor}
    `
      : `
      margin-bottom: 36px;
      box-shadow: ${theme.boxShadow}
    `)};

  ${minMediaQueries.phablet`
    border-radius: ${({ theme }) => theme.borderRadius};
  `};

  ${maxMediaQueries.phablet`
    margin-left: -24px;
    margin-right: -24px;
  `};

  ${maxMediaQueries.phone`
    margin-left: -15px;
    margin-right: -15px;
  `};
`;

export const QuestionDetailInner = styled.div`
  border-radius: 4px;
  background-color: #fff;

  ${minMediaQueries.phablet`
    ${getFont(1)};
  `};
`;
